import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { guideSteps } from "@/mocks/guide";

export default function GuideSteps() {
  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20" aria-label="选群四步法">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="选群方法论"
          title="选对群其实只要四步"
          desc="不需要加十几个群慢慢试。按这套顺序走一遍，基本就能筛掉大部分冷清群和广告群。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((item) => (
            <div
              key={item.step}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="font-heading text-3xl text-primary-200">{item.step}</span>
              <span className="mt-2 flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base text-foreground-950 md:text-lg">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <Link
            to="/guide"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            阅读完整选群指南
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}